module.controller('updateMeetingCntrl', function(xmppAuth, services, theme, $sce, $scope, $rootScope, $cookieStore, $cookies, $mdDialog, $filter, $window, $mdToast) {
      
    $scope.$watch("assignments", function (value) {//I change here
      $('#timepicker').mdtimepicker({format:'h:mm tt', hourPadding: true}, 'show');
      $('#timepicker').mdtimepicker().on('timechanged', function(e){      
        $scope.time = e.time;  
        console.log(e.value);      
        console.log(e.time);      
      });  
    });
 
    $scope.formatAMPM = function(date) {
      var hours = date.getUTCHours();
      var minutes = date.getUTCMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;  
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
  }

    $scope.meeting = JSON.parse($window.sessionStorage.getItem("meeting"));
    $scope.groupId = $window.sessionStorage.getItem("groupId");    
    $scope.groupName = $window.sessionStorage.getItem("groupName");

    $scope.date =   {constraints: { minDate: 0, maxDate: ($scope.meeting.meetingTime * 2)}}; // meeting.meetingTime
    $scope.dateRange = $scope.date.constraints;
    $scope.theme =  JSON.parse($window.sessionStorage.getItem("theme"));
    $scope.isOpen = false;
    var dateWithouthSecond = new Date($scope.meeting.meetingTime)   
    
    
    var currentTime = $scope.formatAMPM(dateWithouthSecond); //.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: true}).replace(". ","").replace(". ","").replace(".","").replace(".","");

    $scope.myTime = currentTime.toUpperCase();
    $scope.myPlace = $scope.meeting.place;
    if($scope.theme !== null) {
      $scope.chatTheme = {header: {background: $scope.theme.statusbar_background_color}, footer: {background: $scope.theme.statusbar_background_color}, bars: {color: $scope.theme.statusbar_textcolor}, message_sent_background_color:{background: $scope.theme.message_sent_background_color}, sent_color:{'border-left': '15px solid' + $scope.theme.message_sent_background_color}, message_receive_background_color:{background: $scope.theme.message_receive_background_color}, receive_color:{'border-right': '15px solid' + $scope.theme.message_receive_background_color}, button_selection_chat:{background: $scope.theme.button_selection_chat_background_color, color: $scope.theme.button_selection_chat_textcolor},button_send:{
        background: $scope.theme.button_send_background_color,
        color: $scope.theme.button_send_textcolor,
        'box-shadow': '0 2px 5px 0 rgba(0, 0, 0, 0.26)'
      }};
    }
    
    $scope.paymentDate= new Date();
    $scope.formats = ['dd-MMMM-yyyy', 'dd-MM-yyyy', 'dd.MM.yyyy', 'shortDate'];
    $scope.theme = theme.getTheme();
    $scope.format = $scope.theme.getDateFormat() || 'dd/MM/yyyy';

    $scope.myDate = new Date($scope.meeting.meetingTime);
    $scope.minDate = new Date($scope.date.constraints.minDate);
    $scope.maxDate = new Date($scope.date.constraints.maxDate);

    $scope.dateOptions = {
        formatYear: 'yy',
        maxDate: new Date($scope.dateRange.maxDate),
        minDate: new Date($scope.dateRange.minDate),
        startingDay: 1
    };
    
   
    $scope.showTimePicker = function() { 
      $('#timepicker').mdtimepicker({format:'h:mm tt', hourPadding: true}, 'show');
    }

    $scope.setConstraints = function(index, minDate, maxDate) {
        var minD = null;
        var maxD = null;

        if(minDate)
          minD = new Date(minDate);
        if(maxDate)
          maxD = new Date(maxDate);

        $scope.dateOptions = {
          formatYear: "yy",
          maxDate: maxD,
          minDate: minD,
          startingDay: 1,
          showWeeks: false
        }
    }; 
      
    $scope.defaultDate = function() {
        var today = new Date($scope.meeting.meetingTime);
        $scope.maxDate = new Date($scope.date.constraints.maxDate);
        if($scope.maxDate && $scope.maxDate < today)
          $scope.paymentDate = $scope.maxDate;
    }

    $scope.paymentDatePopup = {
        opened: false
    };

    $scope.open = function(popup) {
        popup.opened = true;
    };

    $scope.closeDialog = function(){
      $mdDialog.cancel();
    };

    $scope.convert12to24 = function(time) {      
      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if(AMPM == "PM" && hours<12) hours = hours+12;
      if(AMPM == "AM" && hours==12) hours = hours-12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if(hours<10) sHours = "0" + sHours;
      if(minutes<10) sMinutes = "0" + sMinutes;
      return (sHours + ":" + sMinutes);
    }

    $scope.updateMeetings = function() {
      console.log( $scope.convert12to24($scope.myTime));
      console.log($scope.myDate);
      var sTime = $scope.convert12to24($scope.myTime);
      var fulltimes = sTime.split(":");
      var hours = Number.parseInt(fulltimes[0]);
      var mins = Number.parseInt(fulltimes[1]);
      var date = new Date();
      date = $scope.myDate;
      date.setUTCHours( hours);
      date.setUTCMinutes( mins);
      console.log(date);
      console.log(date.getTime());
      $scope.progress = "ok";        
      $scope.references = []; 
      var meeting = $scope.meeting;
      var body =  {
        meetingId: meeting.id,                            
        frequency: meeting.frequency,
        groupId : $scope.groupId,
        meetingTime : date.getTime(),
        place:$scope.myPlace,
        type: meeting.type
      }
    
      services.groups.groupsServices('bearer ' + $window.localStorage.getItem('access_token1')).updateMeeting({ meetingId: meeting.id}, body, function(response) {
          $scope.progress = undefined;
          if (response.code  && response.code == 1) {
            $mdDialog.hide("updateMeeting");
          } 
          else {           
            $scope.msgToast(response.message, "error-toast");
          }
      }, function(error) {
          $scope.showAlert("Ocurrio un error", "Pongase en contacto con soporte tecnico");
      })     
    }
    $scope.msgToast = function(message, type){
      $mdToast.show(
          $mdToast.simple()
          .textContent(message)
          .position('top')
          .action('Ok')
          .theme(type)
          .hideDelay(2000)
      );
    };
}).config(function($mdDateLocaleProvider) {
  // Example of a Spanish localization.
  $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                                  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
                                  'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
  $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
  $mdDateLocaleProvider.firstDayOfWeek = 1;
  // Optional.
  $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
    return 'Semana ' + weekNumber;
  };

  $mdDateLocaleProvider.formatDate = function(date) {
    return moment(date).format('DD/MM/YYYY');
  };

  $mdDateLocaleProvider.parseDate = function(dateString) {
    var m = moment(dateString, 'DD/MM/YYYY', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };
  $mdDateLocaleProvider.msgCalendar = 'Calendario';
  $mdDateLocaleProvider.msgOpenCalendar = 'Abrir calendario';

});
